import React, { useCallback, useState } from 'react';
import { Pinboard } from '@axtria/hqi-genai'
import '@axtria/hqi-genai/lib/hqi-genai.css'
import { useChat } from '../../hooks/useChat';
import { usePinboardReset } from '../../hooks/usePinboardReset';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { DEEP_LINK_PARAMS } from '../../components/Notification/NotificationUtils';

const baseURL = process.env.REACT_APP_HQI_BASE_URL
const middlewareURL = process.env.REACT_APP_HQI_MIDDLEWARE_URL

const PinboardComponent = () => {
  const { userInfo, activeKnowledgeId } = useChat();
      const navigate = useNavigate();

    const handleGoToArtifacts = useCallback(() => {
      navigate('/artifacts');
    }, [navigate]);

  const UMUrl = process.env.REACT_API_URL;

  const { pinboardResetCount } = usePinboardReset();
  // The module keeps "board list vs. opened board" in its own state and exposes
  // no reset prop, so a key bump is the only way back to the list from outside it.
  const [instanceKey, setInstanceKey] = useState(0);

  // Deep link from a notification, e.g. /studio?boardId=42. The module reads it
  // once on mount, so the key includes it to remount for a new target.
  const [searchParams, setSearchParams] = useSearchParams();
  const initialBoardId = searchParams.get(DEEP_LINK_PARAMS.boardId);

  // Drop the deep link so a later remount (reset/refresh) shows the grid, not the board.
  const handleBackToGrid = useCallback(() => {
    if (initialBoardId) setSearchParams({}, { replace: true });
  }, [initialBoardId, setSearchParams]);

  React.useEffect(() => {
    if (pinboardResetCount === 0) return;
    setInstanceKey((key) => key + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pinboardResetCount]);

  return (
    <Pinboard
      key={`${instanceKey}-${initialBoardId || ''}`}
      DOMAIN={baseURL}
      DOMAIN_MIDDLEWARE={middlewareURL}
      DOMAIN_UM={UMUrl}
      PROJECT_ID={userInfo?.preferredProject}
      KNOWLEDGE_ID={activeKnowledgeId}
      USERNAME={`${userInfo?.first_name || ""}`}
        onGoToArtifacts={handleGoToArtifacts}
      initialBoardId={initialBoardId}
      onBackToGrid={handleBackToGrid}
    />
  )
};

export default PinboardComponent;
